module.exports = __webpack_public_path__ + "static/media/no_1.ecd4d4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeFavourableRoll/images/no_1.png
// module id = 436
// module chunks = 0